import React, { Component } from "react";
import Avatar from "@mui/material/Avatar";

import moment from "moment";
import NotificationDetails from "./NotificationDetails";
import EquipmentApi from "../../api/EquipmentApi";
import building from "../../images/building.png";
import equipment from "../../images/equipment.png";
import Vechiles from "../../images/Vechiles.png";

class NotificationGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal : false,
      description : "",
      title : "" ,
      totalvalue : {},
      exactadata: {}
    };
  }

  render() {
    return (
      <>
        <div className="adjust-grid-container">
          <div className="Center-the-Grid">
            <table id="myTable">
              <thead>
                <tr style={{ borderBottom: "1px solid #BCBFBE" }}>
                  <th>Activity Name</th>
                   <th>Create By</th>
                
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
              {this.props.notificationList.map((e) => (
  <tr onClick={() => this.OpenCreateTask(e)}>
    <td style={{ padding: '5px' }} class="avatar-cell">
      <div style={{display :"inline-flex" , gap: "10px"}}>
        <div>
        {e.resourseType === "1" ? (
        <img src={building} alt="building 1"   style={{
          width: "2rem",
          maxWidth: "100%",
          height: "auto",
        }}/>
      ) : e.resourseType === "2" ? (
        <img src={equipment} alt="equipment 2"  style={{
          width: "2rem",
          maxWidth: "100%",
          height: "auto",
        }}/>
      ) : e.resourseType === "3" ? (
        <img src={Vechiles} alt="Vechiles 3"   style={{
          width: "2rem",
          maxWidth: "100%",
          height: "auto",
        }}/>
      ) : <Avatar sx={{ width: 32, height: 32 }}>N</Avatar>}
        </div>
        <div class="name">{e.title}</div>
      </div>
     
     
    </td>
    <td style={{ padding: '5px' }}>{e.senderName}</td>
    <td style={{ padding: '5px' }}>{moment(e.createdDate).format("dddd, D MMMM YYYY")}</td>
  </tr>
))}
              </tbody>
              {this.props.notificationList.length === 0 && (
                <>
                  {" "}
                  <div
                    style={{
                      fontSize: "larger",
                      fontWeight: "bolder",
                      
                    }}
                  >
                    {("No Data Found")}
                  </div>{" "}
                </>
              )}
            </table>
            {this.state.openModal && (
          <NotificationDetails
            handleClose={this.closeHandleclose}
            show={this.state.openModal}
           fulldescription={this.state.totalvalue}
           exactadata={this.state.exactadata}
   
            

          />
        
        )}
          </div>
        </div>
      </>
    );
  }
 
  OpenCreateTask = (e) => {
    console.log("e in openCreateTask" , e);
    this.setState({
      openModal: true,
      totalvalue : e
    },() => {
      if(this.state.totalvalue.whichnotification === "ServiceRecord" ){
          
        let obj = {
          service_type : e.serviceType,
          servicerecord_Id : parseInt(e.serviceandTaskid)
        }

          EquipmentApi.togetFullDataByServiceTypeandResourceIdNotification(obj).then((response) => {
             this.setState({
              exactadata :  response.data.data
             })
          })



      }
    });
  };

  closeHandleclose = () => {
    this.setState({
      openModal: false,
    });
  };

}
export default NotificationGrid;
